import React from "react";
import PropTypes from "prop-types";
import { v4 as uuidv4 } from 'uuid';

import Group from "./Apparatus/group/Group"
import { Pipette } from "./Apparatus/Pipette"
import { TipBox } from "./Apparatus/TipBox"
import { Trash } from "./Apparatus/Trash"
import { Solution } from "./Apparatus/Solution"
import { Microcentrifuge } from "./Apparatus/Microcentrifuge"
import { IceBucket } from "./Apparatus/IceBucket"
import { GelBox } from "./Apparatus/gelBox"
import { WaterBath } from "./Apparatus/waterBath"
import { Transilluminator } from "./Apparatus/Transilluminator"
import { FloatingTubeRack } from "./Apparatus/floatingTubeRack"
import { PowerSupply } from "./Apparatus/powerSupply"

import { Flask } from "./Apparatus/flask"
import { PowerSupplyLead }  from "./Apparatus/powerSupplyLead"
import { HeatBlock } from "./Apparatus/HeatBlock"
import { Timer } from "./Apparatus/Timer"

import TubeStand from "./Apparatus/TubeStand/TubeStand"
import Shelf from "./Apparatus/Shelf/Shelf"
import { RotorAdapters } from "./Apparatus/RotorAdapters"
import { AgaroseGel } from "./Apparatus/AgaroseGel"
import { Marker } from "./Apparatus/Marker"
// import Transilluminator from "./Apparatus/Transilluminator/Transilluminator"
import Table from "./Apparatus/Table/Table"
import PipetteRack from "./Apparatus/PipetteRack/PipetteRack"

import "./style.scss";

export class ProtocolScene extends React.Component {

  constructor(props) {
    super(props);

    this.state = {};
  }
  componentDidMount() {}

  doCompPart = data => {
    let groupArr = [];
    let compArr = [];

    this.props.setUUID(uuidv4());

    Object.keys(data).forEach((key, index) => {
      compArr = [];
      data[key].components.forEach((comp, index) => {
        compArr.push(this.buildComponent(comp, index));
      });
      groupArr.push(
        <Group key={index} components={compArr} position={data[key].position} />
      );
    });

    return groupArr
  };

  buildComponent = (data, index) => {
    switch (data.component) {

      case "Pipette":
        return <Pipette defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Tip Box":
        return <TipBox defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Trash":
        return <Trash defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Microcentrifuge":
        return <Microcentrifuge defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Ice Bucket":

        return <IceBucket defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      // case "Thermocycler":
      //   return <Thermocycler defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Gel Box":
        return <GelBox  defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Power Supply":
        return <PowerSupply  defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Power Supply Lead":
        return <PowerSupplyLead  defaultProps={data.props} key={index} pos={data.position} id={data.props.id} sceneScale={this.props.sceneScale} userScale={this.props.userScale} />;

      case "Flask":
      return <Flask  defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Floating Tube Rack":
        return <FloatingTubeRack  defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Water Bath":
        return <WaterBath  defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Rotor Adapters":
        return <RotorAdapters defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Gel":
        return <AgaroseGel defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Marker":
        return <Marker defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

    case "Transilluminator":
      return <Transilluminator defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Solution":
        return <Solution defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;


      case "SolutionTwo":
        return <Solution defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Heat Block":
        return <HeatBlock defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      case "Timer":
        return <Timer defaultProps={data.props} key={index} pos={data.position} id={data.props.id} />;

      // case "Tube":
      //     return <Tubes key={index} pos={data.position} id={data.props.id} />;

      case "Table":
        return <Table key={index} pos={data.position} id={data.props.id} />;

      case "Shelf":
        return <Shelf key={index} pos={data.position} id={data.props.id} />;
      case "ShelfTwo":
        return <Shelf key={index} pos={data.position} id={data.props.id} />;

      case "Pipette Rack":
        return <PipetteRack key={index} pos={data.position} id={data.props.id} />;

      case "Tube Stand":
        return <TubeStand key={index} pos={data.position} id={data.props.id} />;
        
      case "Tube Stand Two":
        return <TubeStand key={index} pos={data.position} id={data.props.id} />;

      case "Tube Stand Three":
        return <TubeStand key={index} pos={data.position} id={data.props.id} />;

      // case "Poster":
      //   return <Poster key={index} pos={data.position} id={data.props.id} />;

      default:
        break;
    }
  };

  render() {
    return this.doCompPart(this.props.apparatus);
  }
}

ProtocolScene.propTypes = {
  optionHolders: PropTypes.array.isRequired,
};
